
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/components/email-verification/parts/verification-complete.vue', {"complete.login":{"ru_RU":"Почта для входа {isChange, select, true {изменена} other {подтверждена}}","en_US":"Login Email is {isChange, select, true {changed} other {confirmed}}"},"complete.notification":{"ru_RU":"Почта для уведомлений {isChange, select, true {изменена} other {подтверждена}}","en_US":"Notifications Email is {isChange, select, true {changed} other {confirmed}}"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/components/email-verification/parts/verification-complete.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  